import OwnGame from "./OwnGame";

export default OwnGame;
